import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FibroidsPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Fibroids</h1>
        <section className="mb-8">
          <p>Fibroids are noncancerous growths in the uterus that can cause pain, heavy bleeding, and fertility issues. Our natural therapies focus on shrinking fibroids, balancing hormones, and supporting reproductive health through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Genetic predisposition</li>
            <li>Obesity</li>
            <li>High estrogen levels</li>
            <li>Family history</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Heavy menstrual bleeding</li>
            <li>Pelvic pain or pressure</li>
            <li>Frequent urination</li>
            <li>Constipation</li>
            <li>Difficulty conceiving</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use hormone-balancing herbs, anti-inflammatory remedies, and lifestyle modifications to naturally treat fibroids. Our approach focuses on shrinking fibroids, balancing hormones, and supporting reproductive health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Shrinks fibroids naturally</li>
            <li>Balances hormones</li>
            <li>No harsh side effects</li>
            <li>Supports fertility</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a healthy weight</li>
            <li>Eat a balanced diet</li>
            <li>Exercise regularly</li>
            <li>Manage stress</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for women trying to conceive?</strong>
            <p>A: Yes, our natural remedies are safe and can support fertility and reproductive health.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes and promoting hormonal balance.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from fibroids—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FibroidsPage; 